import TextInput from "./textInput";
import PasswordField from "./passwordField";
import SelectInput from "./selectInput";
import CheckboxInput from "./CheckboxInput";
import RadioInput from "./radioInput";
import RadioGroupInput from "./radioGroupInput";
import PhoneInput from "./PhoneInput";
import DateInput from "./dateInput";
import AutocompleteInput from "./autocompleteInput";
export function renderInputComponent(
	field,
	formData,
	formikField,
	meta,
	handleChange,
	style
) {
	// console.log(field);
	
	switch (field.type) {
		case "text":
			return (
				<TextInput
					{...formikField}
					meta={meta}
					label={field.label}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
					fullWidth={field.fullWidth}
				/>
			);
		case "password":
			return (
				<PasswordField
					{...formikField}
					meta={meta}
					label={field.label}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
					fullWidth={field.fullWidth}
				/>
			);
		case "dropdown":
			return (
				<SelectInput
					{...formikField}
					meta={meta}
					label={field.label}
					options={field.options}
					value={formData[field.name] || ""}
					onChange={handleChange}
					fullWidth={field.fullWidth}
				/>
			);
		case "checkbox":
			return (
				<CheckboxInput
					{...formikField}
					meta={meta}
					label={field.label}
					value={formData[field.name] || ""}
					checked={formData[field.name] || false}
					onChange={handleChange}
					required={field.required}
					style={style}
				/>
			);
		case "radio":
			return (
				<RadioInput
					{...formikField}
					meta={meta}
					label={field.label}
					// value={field.value}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
				/>
			);
		case "radioGroup":
			return (
				<RadioGroupInput
					{...formikField}
					meta={meta}
					label={field.label}
					options={field.options}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
				/>
			);
		case "number":
			return (
				<PhoneInput
					{...formikField}
					meta={meta}
					label={field.label}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
					fullWidth={field.fullWidth}
				/>
			);
		case "datePicker":
			return (
				<DateInput
					{...formikField}
					meta={meta}
					label={field.label}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
					fullWidth={field.fullWidth}
				/>
			);
		case "autocomplete":
			return (
				<AutocompleteInput
					{...formikField}
					meta={meta}
					label={field.label}
					options={field.options}
					value={formData[field.name] || ""}
					onChange={handleChange}
					required={field.required}
					style={style}
					fullWidth={field.fullWidth}
				/>
			);
		default:
			return (
				<TextInput
					{...formikField}
					meta={meta}
					label={field.label}
					value={formData[field.name] || ""}
					onChange={handleChange}
					// required={field.required}
					style={style}
					required="default"
					fullWidth={field.fullWidth}
				/>
			);
	}
}
